import { Store } from '../store';

function checkFeature(featureName) {
  const { featureMap } = Store;
  return !!featureMap.get(featureName) === true;
}

export default checkFeature;
